import { render, staticRenderFns } from "./EventStatus.vue?vue&type=template&id=23b71c41&"
import script from "./EventStatus.vue?vue&type=script&lang=js&"
export * from "./EventStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports